module.exports = __webpack_public_path__ + "static/Path4-a4e4a264ecb3483389d87cf64a1f0f1f.svg";